import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.block017_scrollinglogos .logo-slider-splide').forEach((slider) => {
        if (slider.classList.contains('is-initialized')) {
            return;
        }

        const perPage = Number.parseInt(slider.dataset.perPage, 10) || 6;
        const perPageTablet = Number.parseInt(slider.dataset.perPageTablet, 10) || 4;
        const perPageMobile = Number.parseInt(slider.dataset.perPageMobile, 10) || 2;
        const autoplay = slider.dataset.autoplay === 'true';
        const arrows = slider.dataset.arrows === 'true';

        let moved = false;

        const splide = new Splide(slider, {
            type: 'loop',
            drag: 'free',
            snap: false,
            flickPower: 300,
            perPage,
            perMove: 1,
            gap: '20px',
            pagination: false,
            arrows,
            autoplay,
            interval: 4000,
            speed: 600,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            pauseOnHover: true,
            pauseOnFocus: true,
            breakpoints: {
                1024: {
                    perPage: perPageTablet,
                },
                600: {
                    perPage: perPageMobile,
                },
            },
        });

        splide.on('dragging', () => {
            moved = true;
        });

        splide.on('dragged', () => {
            window.setTimeout(() => {
                moved = false;
            }, 0);
        });

        slider.addEventListener('click', (event) => {
            if (moved && event.target.closest('a')) {
                event.preventDefault();
            }
        }, true);

        splide.mount();
    });
});
